module.exports = __webpack_public_path__ + "img/sv.a2206491.jpg";